import { useState } from "react";
import { Check } from "lucide-react";
import { toast } from "sonner";
import { api, today, useSubmit } from "@/lib/api";
import { ErrorBox, Field, Modal } from "@/components/common";
import PatientPicker from "@/components/PatientPicker";

export default function AppointmentForm({ patientId, appointment, onClose, onSaved }) {
  const [form, setForm] = useState(appointment || { patient_id: patientId || "", date: today(), time: "", purpose: "", notes: "" });
  const { busy, error, run } = useSubmit();
  const set = (k) => (v) => setForm({ ...form, [k]: v });
  const save = () => run(async () => {
    const body = { date: form.date, time: form.time || "", purpose: form.purpose, notes: form.notes || "" };
    const r = appointment ? await api.patch(`/appointments/${appointment.id}`, body) : await api.post("/appointments", { ...body, patient_id: form.patient_id });
    toast.success(appointment ? "Appointment rescheduled" : `Follow-up booked for ${r.data.date}`);
    onSaved(r.data);
  });
  return (
    <Modal eyebrow="APPOINTMENTS" title={appointment ? "Reschedule" : "Book follow-up"} onClose={onClose} onSubmit={save} testid="appointment-form">
      {!patientId && !appointment && <PatientPicker value={form.patient_id} onChange={set("patient_id")} testid="appointment-patient-select" />}
      <div className="form-two">
        <Field label="Date" type="date" required testid="appointment-date-input" value={form.date} onChange={set("date")} />
        <Field label="Time (optional)" type="time" testid="appointment-time-input" value={form.time} onChange={set("time")} />
      </div>
      <Field label="Purpose" required testid="appointment-purpose-input" value={form.purpose} onChange={set("purpose")} placeholder="e.g. RCT second sitting, 36" />
      <Field label="Notes" textarea rows={2} testid="appointment-notes-input" value={form.notes} onChange={set("notes")} />
      <ErrorBox error={error} testid="appointment-form-error" />
      <button className="primary full" disabled={busy} data-testid="save-appointment-button"><Check size={17} /> {busy ? "Saving…" : appointment ? "Save new time" : "Book appointment"}</button>
    </Modal>
  );
}
